<template>
    <div class="borrow">
        <div class="headliner">
            <img src="../assets/pitch.png" style="height: 140px; margin-bottom: 12px">
            <h1 class="title">Pitch Yourself</h1>
            <p class="subtitle">Record or upload your video loan request to our network of lenders</p>
            <get-verified-prompt v-if="verified !== true" :to="'borrow'"></get-verified-prompt>
        </div>
       <md-steppers md-vertical :md-active-step.sync="active" class="stepper">
           <!-- TODO: Make upload step 1 and add % done count to stepper header label -->
           <!-- TODO: Check if upload continues in background while user fills out form -->
           <md-step id="loanDetails" md-label="Loan Details" :md-done.sync="loanDetails">
               <loan-details
                       :principal.sync="loan.principal"
                       :interest.sync="loan.interest"
                       :due.sync="loan.due"
               ></loan-details>
               <b-button
                       class="button"
                       @click="setDone('loanDetails', 'postText')"
                       v-if="loan.principal"
               >Next</b-button>
           </md-step>
           <md-step id="postText" md-label="Write your post" :md-done.sync="postText">
               <post-text
                       :headline.sync="loan.headline"
                       :body.sync="loan.body"
               ></post-text>
               <b-button
                       class="button"
                       @click="setDone('postText', 'upload')"
                       v-if="loan.headline"
               >Next</b-button>
           </md-step>
           <md-step id="upload" md-label="Upload Your Video" :md-done.sync="upload">
               <upload-video
                       :video_tmp.sync="loan.video_tmp"
               ></upload-video>
           </md-step>
           <b-button
                   type="is-primary" class="final_btn" size="is-medium"
                   v-if="loan.principal && loan.headline && loan.video_tmp"
                   @click="post"
                   :disabled="submitBtnDisable"
           >
               {{submitBtn}}
           </b-button>
       </md-steppers>
        <success-alert :show-dialog.sync="showDialog"></success-alert>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import UploadVideo from "../components/upload-video";
    import LoanDetails from "../components/loan-details";
    import PostText from "../components/post-text";
    import SuccessAlert from "../components/success-alert";
    import GetVerifiedPrompt from "../components/get-verified-prompt";

    export default {
        name: "Borrow",
        components: {SuccessAlert, PostText, LoanDetails, UploadVideo, BButton, GetVerifiedPrompt},
        data: () => ({
            verified: localStorage.getItem('verified'),
            active: 'loanDetails',
            loanDetails: false,
            postText: false,
            upload: false,
            loan: {
                principal: null,
                interest: null,
                due: null,
                headline: null,
                body: null,
                video_tmp: null,
                uid: localStorage.user
            },
            submitBtn: "Post Your Loan Pitch",
            submitBtnDisable: false,
            showDialog: false
        }),
        methods: {
            setDone (id, index) {
                this[id] = true;
                if (index) {
                    this.active = index
                }
            },
            post() {
                const vm = this;
                vm.submitBtn = "Please wait...";
                vm.submitBtnDisable = true;
                let config = {
                    headers: {'Authorization': "bearer " + localStorage.token}
                };
                let url = vm.$host + "/match/post";
                vm.axios.post(url, vm.loan, config)
                    .then(function (res) {
                        vm.showDialog = true;
                    }).catch(function (e) {
                        alert(e)
                    })
            }
        },
        mounted() {
            this.showDialog = false;
            const now = new Date().getTime();
            const refreshTime = localStorage.expiry - 3600000;
            if(!localStorage.token || now > refreshTime) {
                this.$router.push({name: 'login', query: { to: 'borrow' }})
            }
        }
    }
</script>

<style scoped>
    .headliner {
        padding: 28px;
        padding-bottom: 16px;
    }

    .stepper {
        text-align: left;
    }

    .button {
        margin-top: 28px;
        width: 48%;
    }

    .final_btn {
        font-family: "Work Sans";
        width: 90%;
        margin:5%;
    }
</style>